import { Card, CardContent } from "@/components/ui/card";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/catalyst/button";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { CreateWorkOrderAssignmentDialog } from "@/app/ProDrivers/WorkOrders/Components/Dialogs/CreateWorkOrderAssignmentDialog";
import { useTranslations } from "use-intl";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";

interface WorkOrderEmptyDriverCardProps {
  workOrderId: string;
  index: number;
}

export function WorkOrderEmptyDriverCard({
  workOrderId,
  index,
}: WorkOrderEmptyDriverCardProps) {
  const { open } = useDialog(CreateWorkOrderAssignmentDialog);
  const t = useTranslations("workOrder.cards.driver");
  const { isAdmin } = useTenant();

  return (
    <Card
      className={
        isAdmin
          ? "cursor-pointer border-2 border-dashed border-gray-300 transition-colors hover:border-gray-400 hover:bg-gray-50"
          : "border-2 border-dashed border-gray-300"
      }
      onClick={isAdmin ? () => open({ workOrderId }) : undefined}
    >
      <CardContent className="flex flex-col items-center justify-center py-8">
        <div className="flex size-12 items-center justify-center rounded-full bg-gray-100">
          <UserPlusIcon className="size-6 text-gray-400" />
        </div>
        <h3 className="mt-3 text-sm font-medium text-gray-900">
          {t("title", { number: index + 1 })}
        </h3>
        <p className="mt-1 text-xs text-gray-500">{t("noDriverYet")}</p>
        {isAdmin ? (
          <Button outline className="pointer-events-none mt-4">
            {t("addDriver")}
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
}
